import moment from 'moment/moment';
import React, { useEffect, useState, useMemo } from 'react';
import { SimpleBarChart, PieChart } from '@carbon/charts-react';
import '@carbon/charts-react/styles.css';

const monthMapping = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
};

export default function Charts({ allProperties, allLandlords }) {
  const [objForListing, setObjForListing] = useState({
    'Draft': 0,
    'Submitted for Listing': 0,
    'Future': 0,
    'Listed': 0,
    'Un list Requested': 0,
    'Un listed': 0,
    'Ending': 0,
    'Expired': 0,
  });
  const [recentRegistrations, setRecentRegistrations] = useState({});

  useMemo(() => {
    const tempObjForListing = {...objForListing};
    allProperties && allProperties?.forEach((property) => {
      tempObjForListing[property?.status] = Number(tempObjForListing[property?.status]) + 1;
    });

    setObjForListing(tempObjForListing);
  }, [allProperties]);

  useMemo(() => {
    const tempRecentRegistrations = {...recentRegistrations};
    allLandlords && allLandlords?.forEach((landlord) => {
      const date = moment(landlord?.createdAt).format('DD/MM/YYYY');
      if (tempRecentRegistrations[date]) {
        tempRecentRegistrations[date] = tempRecentRegistrations[date] + 1;
      } else {
        tempRecentRegistrations[date] = 1;
      }
    });
    
    setRecentRegistrations(tempRecentRegistrations);
  }, [allLandlords]);

  const pieChart = () => {
    const pieChartData = [];
    for (const key in objForListing) {
      pieChartData.push({ group: key, value: objForListing[key] });
    }
  
    const pieChartOptions = {
      title: 'Properties status',
      resizable: true,
      width: "97%",
      height: "400px",
    };
  
    return { pieChartData, pieChartOptions };
  }

  const barChart = () => {
    const tempRecentRegistrationsArray = Object.keys(recentRegistrations);
    tempRecentRegistrationsArray.sort((a, b) => a - b);
    const barChartData = [];

    tempRecentRegistrationsArray?.slice(-5).forEach((key) => {
      const dateArray = key.split('/');
      barChartData.push({ group: `${monthMapping[dateArray[1]]} ${dateArray[0]}`, value: recentRegistrations[key] });
    });
  
    const barChartOptions = {
      title: 'Recent Registrations',
      axes: {
        left: {
          mapsTo: 'value'
        },
        bottom: {
          mapsTo: 'group',
          scaleType: 'labels'
        }
      },
      width: "97%",
      height: "400px",
    };
  
    return { barChartData, barChartOptions };
  }

  const { pieChartData, pieChartOptions } = pieChart();
  const { barChartData, barChartOptions } = barChart();

  return (
    <>
      <div className="charts-component">
        <div style={{ width: '100%' }}>
          <PieChart data={pieChartData} options={pieChartOptions} />
        </div>
        <div style={{ width: '100%' }}>
          <SimpleBarChart data={barChartData} options={barChartOptions} />
        </div>
      </div>
    </>
  );
}
